/**
 * The font family for native chrome that takes style objects the CSS layer never sees, such as
 * React Navigation's header and the tab bar.
 *
 * Kept in a leaf module. Importing it from `NavigationChrome.tsx` would pull in
 * `CustomerFacingToggle`, `CustomerFacingProvider` and its device state, vendor-only chrome that
 * the true root (`app/_layout.tsx`, which also serves the public `browse` and `account-deletion`
 * routes) must not import.
 */
export const NATIVE_HEADER_TITLE_STYLE = {
  fontFamily: "BricolageGrotesque_700Bold",
} as const;
